export const ClockIcon = ({
  className,
  styles,
}: {
  className?: string;
  styles?: any;
}) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={styles}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.2 14.4C11.1764 14.4 14.4 11.1764 14.4 7.2C14.4 3.22355 11.1764 0 7.2 0C3.22355 0 0 3.22355 0 7.2C0 11.1764 3.22355 14.4 7.2 14.4ZM8.1 3.6C8.1 3.10294 7.69706 2.7 7.2 2.7C6.70294 2.7 6.3 3.10294 6.3 3.6V7.2C6.3 7.43869 6.39482 7.66761 6.5636 7.8364L9.10919 10.382C9.46066 10.7335 10.0305 10.7335 10.382 10.382C10.7335 10.0305 10.7335 9.46066 10.382 9.10919L8.1 6.82721V3.6Z"
      fill="currentColor"
    />
  </svg>
);
